import { Field, FieldProps, useFormikContext } from 'formik';
import { CheckboxInput } from 'lib/components';

import { Gap } from 'lib/components/styles/layout';
import React from 'react';
import {
  CheckboxLabel,
  CheckboxWrapper,
  Section,
  SectionTitle,
} from '../index.styled';
import { SalesPagesValues } from './types';
import { useTranslation } from 'react-i18next';

export const SalesPagesSocialIconsForm = () => {
  const { setFieldValue, values } = useFormikContext<SalesPagesValues>();
  const { t } = useTranslation();

  return (
    <Section>
      <SectionTitle>{t('Social Icons')}</SectionTitle>
      <Gap>
        <Field name={'socialIcons'}>
          {({ field }: FieldProps) => {
            return (
              <CheckboxWrapper>
                <CheckboxInput
                  {...field}
                  checked={field.value}
                  onChange={() => {
                    setFieldValue(`socialIcons`, !values.socialIcons);
                  }}
                />
                <CheckboxLabel>{t('Show/hide')}</CheckboxLabel>
              </CheckboxWrapper>
            );
          }}
        </Field>
      </Gap>
    </Section>
  );
};
